import {NgModule} from '@angular/core';
import {CapacityOfCommentToDisplayNamePipe} from './capacity-of-comment-to-display-name.pipe';

@NgModule({
  declarations: [CapacityOfCommentToDisplayNamePipe],
  exports: [CapacityOfCommentToDisplayNamePipe],
})
export class CapacityOfCommentToDisplayNameModule {}
